import "bootstrap/dist/css/bootstrap.min.css";
import { onValue, ref, remove } from "firebase/database";
import { useEffect, useState } from "react";
import { db } from "../Firebase";

const MastersData = () => {
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [areas, setAreas] = useState([]);

  const [relations, setRelations] = useState([]);
  const [castes, setCastes] = useState([]);
  const [motherTongues, setMotherTongues] = useState([]);
  const [temples, setTemples] = useState([]);
  const [familyStatus, setFamilyStatus] = useState([]);
  const [houseStatus, setHouseStatus] = useState([]);
  const [deletingIds, setDeletingIds] = useState([]);

  /* ================= FETCH ================= */
  useEffect(() => {
    const fetch = (path, setter) => {
      onValue(ref(db, path), (snap) => {
        if (snap.exists()) {
          const data = Object.entries(snap.val()).map(([id, v]) => ({
            id,
            ...v,
          }));
          setter(data);
        } else setter([]);
      });
    };

    fetch("masters/countries", setCountries);
    fetch("masters/states", setStates);
    fetch("masters/districts", setCities);
    fetch("masters/blocks", setAreas);

    fetch("masters/relations", setRelations);
    fetch("masters/castes", setCastes);
    fetch("masters/motherTongues", setMotherTongues);
    fetch("masters/temples", setTemples);
    fetch("masters/familyStatus", setFamilyStatus);
    fetch("masters/houseStatus", setHouseStatus);
  }, []);

  /* ================= MERGE LOCATION DATA ================= */
  const locationRows = areas.map((a) => ({
    id: a.id,
    country: a.country,
    state: a.state,
    city: a.district,
    area: a.name,
  }));

  /* ================= DELETE ================= */
  const handleDelete = async (path, id) => {
    if (!window.confirm("Are you sure to delete?")) return;

    // normalize path and id to avoid accidental double-slashes
    const clean = (p) => p.replace(/(^|\/+)\/+/g, "/").replace(/\/$/, "");
    const fullPath = clean(`${path}/${id}`);

    try {
      setDeletingIds((s) => [...s, id]);
      console.log("Deleting", fullPath);
      await remove(ref(db, fullPath));
      console.log("Deleted", fullPath);
      alert("Deleted successfully");
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Failed to delete. See console for details.");
    } finally {
      setDeletingIds((s) => s.filter((x) => x !== id));
    }
  };

  return (
    <div className="container mt-4">
      <h4 className="mb-3">📊 Masters Data</h4>

      {/* ================= LOCATION TABLE ================= */}
      <div className="card mb-4">
        <div className="card-header fw-bold">📍 Location Masters</div>

        <div className="table-responsive">
          <table className="table table-bordered table-striped mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Country</th>
                <th>State</th>
                <th>City</th>
                <th>Area</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {locationRows.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center text-muted">
                    No data found
                  </td>
                </tr>
              ) : (
                locationRows.map((r, i) => (
                  <tr key={r.id}>
                    <td>{i + 1}</td>
                    <td>{r.country}</td>
                    <td>{r.state}</td>
                    <td>{r.city}</td>
                    <td>{r.area}</td>
                    <td>
                      <button className="btn btn-sm btn-outline-primary me-2">
                        Edit
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() =>
                          handleDelete("masters/blocks", r.id)
                        }
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= OTHER MASTERS (UNCHANGED) ================= */}
      <Table
        title="📂 Other Masters"
        headers={["#", "Type", "Name", "Actions"]}
        rows={[
          ...relations.map((r) => ({ ...r, type: "Relation" })),
          ...castes.map((c) => ({ ...c, type: "Caste" })),
          ...motherTongues.map((m) => ({ ...m, type: "Mother Tongue" })),
          ...temples.map((t) => ({ ...t, type: "Temple" })),
          ...familyStatus.map((f) => ({ ...f, type: "Family Status" })),
          ...houseStatus.map((h) => ({ ...h, type: "House Status" })),
        ]}
        onDelete={handleDelete}
        deletingIds={deletingIds}
      />
    </div>
  );
};

/* ================= OTHER TABLE ================= */

const Table = ({ title, headers, rows, onDelete, deletingIds = [] }) => {
  const typeToPath = {
    Relation: "relations",
    Caste: "castes",
    "Mother Tongue": "motherTongues",
    Temple: "temples",
    "Family Status": "familyStatus",
    "House Status": "houseStatus",
  };

  return (
    <div className="card mb-4">
      <div className="card-header fw-bold">{title}</div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-0">
          <thead className="table-light">
            <tr>
              {headers.map((h, i) => (
                <th key={i}>{h}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={headers.length} className="text-center text-muted">
                  No data found
                </td>
              </tr>
            ) : (
              rows.map((r, i) => (
                <tr key={r.id}>
                  <td>{i + 1}</td>
                  <td>{r.type}</td>
                  <td>{r.name}</td>
                  <td>
                    <button className="btn btn-sm btn-outline-primary me-2">
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      disabled={deletingIds.includes(r.id)}
                      onClick={() => {
                        const pathKey = typeToPath[r.type];
                        if (!pathKey) {
                          // fallback: attempt original behavior
                          onDelete(`masters/${r.type.toLowerCase().replace(" ", "")}s`, r.id);
                        } else {
                          onDelete(`masters/${pathKey}`, r.id);
                        }
                      }}
                    >
                      {deletingIds.includes(r.id) ? "Deleting..." : "Delete"}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MastersData;
